<div class="page-container m-0">
  <form [formGroup]="missedService" (ngSubmit)="onPublicCaseFormSubmit()">
    <app-public-case-form
      [parentForm]="missedService"
      [errorStateMatcher]="errorMatcher"
      [descriptionPlaceholderText]="descriptionPlaceholderText"
      [caseTypeId]="SUPPORT_TYPES.MISSED_SERVICE"
      country="us"
      supportType="muni-support"
      (fileEncoding)="setFileEncoding($event)"
      (base64String)="setBase64String($event)">
    </app-public-case-form>
    <div class="row submit-container pt-4">
      <div class="col-xs-6 col-auto">
        <app-submit-input
          [disabled]="!missedService.valid || fileIsEncoding"
          [parentForm]="missedService"
          controlName="submit"
          value="Submit">
        </app-submit-input>
      </div>
      <div
        id="cancel-input-container"
        [formGroup]="missedService"
        class="col-xs-6 col-auto">
        <button
          color="primary"
          [disabled]="!missedService.dirty || !missedService.touched"
          [ngClass]="
            !missedService.dirty || !missedService.touched ? 'disabled' : null
          "
          class="cancel-button"
          type="button"
          (click)="onPublicCaseFormCancel()">
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
